module.exports = __webpack_public_path__ + "assets/img/liulan.1b079461.png";